import React, { useState } from 'react';
import { SelectedGarmentSizeContextType } from './types/SelectedGarmentSizeContextType';

export const SelectedGarmentSizeContext =
  React.createContext<SelectedGarmentSizeContextType | null>(null);

type SelectedGarmentSizeProviderProps = {
  children: React.ReactNode;
};

const SelectedGarmentSizeProvider: React.FC<
  SelectedGarmentSizeProviderProps
> = ({ children }) => {
  const [selectedGarmentSizeId, setSelectedGarmentSizeId] = useState([
    0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const saveSelectedGarmentSizeId = (garmentId: number, sizeId: number) => {
    let sizes: number[] = [];
    selectedGarmentSizeId.map((id) => sizes.push(id));
    sizes[garmentId] = sizeId;
    setSelectedGarmentSizeId(sizes);
  };
  const resetSelectedGarmentSizeId = () => {
    setSelectedGarmentSizeId([0, 0, 0, 0, 0, 0, 0, 0]);
  };
  return (
    <SelectedGarmentSizeContext.Provider
      value={{
        selectedGarmentSizeId,
        saveSelectedGarmentSizeId,
        resetSelectedGarmentSizeId,
      }}
    >
      {children}
    </SelectedGarmentSizeContext.Provider>
  );
};

export default SelectedGarmentSizeProvider;
